// extracted by mini-css-extract-plugin
export default {"box":"index_box_mv2dJ"};